var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 343.074,
    height: 408.893,
    viewBox: "0 0 343.074 408.893",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_647",
    x: 198.802,
    y: 0,
    width: 144.272,
    height: 144.272,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_647-2",
    x: 104.545,
    y: 85.236,
    width: 144.017,
    height: 144.017,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_647-3",
    x: 0,
    y: 169.046,
    width: 144.252,
    height: 144.252,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Step_1",
    "data-name": "Step 1",
    transform: "translate(-731.385 -145.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32087",
    "data-name": "Group 32087",
    transform: "translate(946.904 180.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13726",
    "data-name": "Path 13726",
    d: "M100.018,228.38l53.5,27.874L154.633,51.21,100.018,23.357Z",
    transform: "translate(-99.994 33.575)",
    fill: "#136189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13727",
    "data-name": "Path 13727",
    d: "M140.018,51.4V256.42l53.5-24.392V27.005Z",
    transform: "translate(-86.498 33.41)",
    fill: "#136da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13728",
    "data-name": "Path 13728",
    d: "M154.322,0,100,22.3,153.521,123.55l53.494-97.767Z",
    transform: "translate(-100 34.632)",
    fill: "#258bbf"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Step_3",
    "data-name": "Step 3",
    transform: "translate(31.428 73.456)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Step 3")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-22",
    transform: "translate(34.97) rotate(8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, -0.14, 0.14, 0.99, -252.92, 0.2)",
    filter: "url(#Ellipse_647)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_647-4",
    "data-name": "Ellipse 647",
    cx: 24.026,
    cy: 24.026,
    r: 24.026,
    transform: "translate(250.49 35) rotate(8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13083",
    "data-name": "Path 13083",
    d: "M10.483,17.537,0,10.528,2.446,6.875l7.031,4.7L18.215,0l3.512,2.654Z",
    transform: "translate(13.163 15.946)",
    fill: "#00ff1d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32088",
    "data-name": "Group 32088",
    transform: "translate(854.429 265.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13729",
    "data-name": "Path 13729",
    d: "M50.018,261.552l53.5,27.874,1.118-159.217L50.018,102.357Z",
    transform: "translate(-49.994 -45.215)",
    fill: "#3a93ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13730",
    "data-name": "Path 13730",
    d: "M143.514,265.2l-53.5,24.391V130.4l53.5-24.39Z",
    transform: "translate(-36.497 -45.38)",
    fill: "#40accc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13731",
    "data-name": "Path 13731",
    d: "M103.521,202.55,50,101.3,104.323,79l52.693,25.784Z",
    transform: "translate(-50 -44.158)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Step_2",
    "data-name": "Step 2",
    transform: "translate(32.423 77.484)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Step 2")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-22-2",
    "data-name": "freepik--speech-bubble-2--inject-22",
    transform: "translate(33.157) rotate(8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, -0.14, 0.14, 0.99, -171.41, -97.33)",
    filter: "url(#Ellipse_647-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_647-5",
    "data-name": "Ellipse 647",
    cx: 23.913,
    cy: 23.913,
    r: 23.913,
    transform: "translate(156.2 120.24) rotate(8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13083-2",
    "data-name": "Path 13083",
    d: "M10.434,17.454,0,10.479,2.434,6.842l7,4.675L18.13,0l3.5,2.642Z",
    transform: "translate(13.101 15.871)",
    fill: "#00ff1d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32089",
    "data-name": "Group 32089",
    transform: "translate(751 349.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32090",
    "data-name": "Group 32090",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13732",
    "data-name": "Path 13732",
    d: "M.018,296.453l53.5,27.874L54.633,205.21.018,177.356Z",
    transform: "translate(0.007 -119.48)",
    fill: "#2790ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13733",
    "data-name": "Path 13733",
    d: "M40.018,205.4v119.1l53.5-24.391v-119.1Z",
    transform: "translate(13.503 -119.645)",
    fill: "#2c9bd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13734",
    "data-name": "Path 13734",
    d: "M0,176.3,54.858,277.551l52.157-97.768L54.322,154Z",
    transform: "translate(0 -118.423)",
    fill: "#3eb2e1"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Step_1-2",
    "data-name": "Step 1",
    transform: "translate(31.915 78.391)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Step 1")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-22-3",
    "data-name": "freepik--speech-bubble-2--inject-22",
    transform: "translate(32.07 0) rotate(8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, -0.14, 0.14, 0.99, -79.58, -194.87)",
    filter: "url(#Ellipse_647-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_647-6",
    "data-name": "Ellipse 647",
    cx: 24.017,
    cy: 24.017,
    r: 24.017,
    transform: "translate(51.69 204.05) rotate(8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13083-3",
    "data-name": "Path 13083",
    d: "M10.479,17.53,0,10.524,2.445,6.872l7.029,4.7L18.209,0l3.511,2.653Z",
    transform: "translate(13.158 15.94)",
    fill: "#00ff1d"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.8f5d45b8f12889cb1307a30e0eec4397.svg";
export { ForwardRef as ReactComponent };